import React, { useEffect, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import axiosCommonInstance from "../../utils/axios/axiosCommonInstance";
import axiosAuthInstance from '../../utils/axios/axiosAuthInstance';
import { MdOutlineClose } from "react-icons/md";
import { RiAlertFill } from "react-icons/ri";
import columns from "./columns";
import toast from "react-hot-toast";
import CustomModal from "../../components/common/CustomModal";

const Company = () => {
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [pages, setPages] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalRows, setTotalRows] = useState(0)
  const [selectedFile, setSelectedFile] = useState(null)
  const [uploadLoading, setUploadLoading] = useState(false)
  const [isFileSelected, setIsFileSelected] = useState(false);

  const fileInputRef = useRef(null);

  const fetchData = async () => {
    try {
      const response = await axiosCommonInstance.get("company/list", {
        page: pages, limit: limit
      });
      if (response.status === 200) {
        const transformedData = response?.data?.result?.docs?.map((item) => ({
          ...item,
          actions: (
            <div className="flex gap-3 items-center justify-center">
              {item?.isBrandingData &&
                <Link to={`view/${item._id}`} className="text-white">
                  <button className="bg-primary w-28 text-white px-4 py-2 rounded focus:outline-none hover:bg-orange-600">
                    View Branding
                  </button>
                </Link>
              }

              {!item?.isBrandingData &&
                <Link to={`add/${item._id}`} className="text-white">
                  <button className=" bg-primary w-28 text-white px-4 py-2 rounded focus:outline-none hover:bg-orange-600">
                    Add Branding
                  </button>
                </Link>
              }

              {item?.isBrandingData &&
                <Link to={`edit/${item._id}`} className="text-white">
                  <button className=" bg-primary w-28 text-white px-4 py-2 rounded focus:outline-none hover:bg-orange-600">
                    Edit Branding
                  </button>
                </Link>
              }

              <Link to={`products/${item._id}`} className="text-white">
                <button className="bg-primary w-28 text-white px-4 py-2 rounded focus:outline-none hover:bg-orange-600">
                  Products
                </button>
              </Link>
            </div>
          ),
        }));
        setData(transformedData);
        setTotalRows(response.data.result.totalDocs)
      }
    } catch (error) {
      toast.error("Server Error!");
    }
  };

  useEffect(() => {
    fetchData()
  }, [pages, limit])

  const handleOpenDeleteModal = (id) => {
    setSelectedCompany(id);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCompany(null);
  };

  const handleDelete = async (id) => {
    setIsDeleteLoading(true);
    try {
      const response = await axiosCommonInstance.delete(`/company/${selectedCompany}`);
      if (response.status === 200) {
        fetchData();
        setIsDeleteLoading(false);
        setIsModalOpen(false)
      }
    } catch (error) {
      setIsDeleteLoading(false);
      setIsModalOpen(false)
    }
  };

  const handlePageChange = (newPage) => {
    setPages(newPage)
  }

  const handleLimitPerPageChange = (newLimit) => {
    setLimit(newLimit)
    setPages(1)
  }

  const handleZipSelect = () => {
    fileInputRef.current.click();
  };

  const handleFileInput = (event) => {
    const file = event.target.files[0];

    if (file) {
      if (file.type !== "application/zip" && !file.name.endsWith(".zip")) {
        toast.error("Only ZIP files are allowed!");
        return;
      }

      setSelectedFile(file);
      setIsFileSelected(true);
    }
  };

  const handleUpload = async () => {
    if (selectedFile) {
      setUploadLoading(true);

      try {
        const formData = new FormData();
        formData.append("file", selectedFile);

        const response = await axiosAuthInstance.post("product/bulk-upload", formData);

        if (response) {
          fetchData();
        }
      } catch (error) {
        console.log('Error uploading file :>> ', error);
      } finally {
        setUploadLoading(false);
        setIsFileSelected(false);
        setSelectedFile(null);
      }
    }
  };


  return (
    <div>
      <div className="flex items-center justify-between border-b px-4 pb-2">
        <h1 className="text-2xl">Company Branding</h1>
        <div>
          <input
            type="file"
            name="zipFile"
            accept=".zip"
            className="hidden"
            ref={fileInputRef}
            onChange={handleFileInput}
          />

          <button
            type="button"
            onClick={handleZipSelect}
            className="bg-orange-500 text-white px-4 py-2 rounded-lg font-medium hover:bg-orange-600 transition"
            disabled={uploadLoading}
          >
            Bulk Upload
          </button>

          {isFileSelected && (
            <div className="mt-4">
              <span className="text-gray-700">Selected file: {selectedFile.name}</span>
              <button
                type="button"
                onClick={handleUpload}
                className="ml-4 w-28 bg-orange-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-orange-700 transition"
                disabled={uploadLoading}
              >
                {uploadLoading ? 'Uploading...' : 'Upload'}
              </button>
            </div>
          )}
          {/* {selectedFile && <span className="text-gray-700">{selectedFile.name}</span>} */}
        </div>
      </div>

      <DataTable
        columns={columns}
        data={data}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        paginationPerPage={limit}
        paginationRowsPerPageOptions={[10, 20, 30]}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleLimitPerPageChange}
      />

      {isModalOpen && (
        <CustomModal handleCloseModal={handleCloseModal}>
          <div className="p-4 relative">
            <div
              className="absolute right-5 cursor-pointer hover:opacity-70"
              onClick={handleCloseModal}
            >
              <MdOutlineClose className="text-2xl" />
            </div>
            <div className="flex flex-col items-center justify-between gap-4">
              <div className="flex flex-wrap justify-center alert-ico">
                <RiAlertFill className="text-5xl" />
              </div>
              <h2>Are you sure you want to delete this Company?</h2>
              <div className="flex gap-4 mt-4">
                <button
                  onClick={handleCloseModal}
                  className="bg-gray-300 px-4 py-2 rounded"
                >
                  No, Cancel
                </button>
                <button
                  onClick={handleDelete}
                  className="bg-red-500 text-white px-4 py-2 rounded"
                >
                  {isDeleteLoading ? (
                    <div className="w-5 h-5 mx-auto border-2 border-white border-solid rounded-full loader animate-spin border-t-transparent" />
                  ) : (
                    "Yes, I'm sure"
                  )}
                </button>
              </div>
            </div>
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default Company;
